import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Interdanza from "./pages/Interdanza";
import ArteNatura from "./pages/ArteNatura";
import Archivio from "./pages/Archivio";
import Novita from "./pages/Novita";
import Gallery from "./pages/Gallery";
import Contatto from "./pages/Contatto";
import Admin from "./pages/Admin";
import CookiePolicy from "./pages/CookiePolicy";
import Regolamento from "./pages/Regolamento";
import CookieBanner from "./components/CookieBanner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};

const SiteLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/chi-siamo" element={<SiteLayout><ChiSiamo /></SiteLayout>} />
            <Route path="/interdanza" element={<SiteLayout><Interdanza /></SiteLayout>} />
            <Route path="/arte-e-natura" element={<SiteLayout><ArteNatura /></SiteLayout>} />
            <Route path="/regolamento-racconta-un-fiore" element={<SiteLayout><Regolamento /></SiteLayout>} />
            <Route path="/archivio" element={<SiteLayout><Archivio /></SiteLayout>} />
            <Route path="/novita" element={<SiteLayout><Novita /></SiteLayout>} />
            <Route path="/gallery" element={<SiteLayout><Gallery /></SiteLayout>} />
            <Route path="/contatti" element={<SiteLayout><Contatto /></SiteLayout>} />
            <Route path="/cookie-policy" element={<SiteLayout><CookiePolicy /></SiteLayout>} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
